import { render, staticRenderFns } from "./TheSpinner.vue?vue&type=template&id=85538ed8&scoped=true"
var script = {}
import style0 from "./TheSpinner.vue?vue&type=style&index=0&id=85538ed8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85538ed8",
  null
  
)

export default component.exports